"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoadMinorVersion = exports.useAsset = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _actions = require("../domains/assets/actions");
var _selectors = require("../domains/assets/selectors");
/** Private method */
var usePortalOnLoad = function usePortalOnLoad() {
  var _React$useContext = _react.default.useContext(_exchangeReactHooks.AssetPortalContext),
    onLoad = _React$useContext.onLoad;
  return onLoad;
};
var useAsset = exports.useAsset = function useAsset(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    version = _ref.version,
    minorVersion = _ref.minorVersion,
    status = _ref.status;
  var store = (0, _reactRedux.useStore)();
  var state = store.getState();
  var dispatch = (0, _reactRedux.useDispatch)();
  var value = (0, _selectors.asset)(state, {
    groupId: groupId,
    assetId: assetId,
    version: version,
    minorVersion: minorVersion,
    status: status
  });
  var _React$useState = _react.default.useState(!value),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _React$useState3 = _react.default.useState(null),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    error = _React$useState4[0],
    setError = _React$useState4[1];
  _react.default.useEffect(function () {
    function init() {
      return _init.apply(this, arguments);
    }
    function _init() {
      _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setError(null);
              setIsLoading(true);
              _context.next = 5;
              return dispatch((0, _actions.getAsset)({
                groupId: groupId,
                assetId: assetId,
                minorVersion: minorVersion,
                version: version,
                status: status
              }));
            case 5:
              setIsLoading(false);
              _context.next = 12;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              setIsLoading(false);
              setError(_context.t0);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      return _init.apply(this, arguments);
    }
    if (groupId && assetId) {
      init();
    }
  }, [dispatch, groupId, assetId, version, minorVersion, status]);
  return {
    isLoading: isLoading,
    error: error,
    value: value
  };
};

/**
 * Returns a function to load a minor version that is not actually being navigated in the portal
 *
 * @example
 *
 * ```ts
 * import { useLoadMinorVersion } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *    const loadMinorVersion = useLoadMinorVersion();
 *
 *   React.useEffect(() => {
 *     async function loadAsset() {
 *       const theOtherAsset = await loadMinorVersion('1.0', 'development');
 *
 *       console.log(theOtherAsset);
 *     }
 *
 *     loadAsset();
 *   });
 *
 *   ...
 * };
 * ```
 *
 * @returns A function to load a minor version from the current asset portal
 */
var useLoadMinorVersion = exports.useLoadMinorVersion = function useLoadMinorVersion() {
  var onLoad = usePortalOnLoad();
  var dispatch = (0, _reactRedux.useDispatch)();
  var portalAsset = (0, _exchangeReactHooks.useAsset)();
  var config = (0, _exchangeReactHooks.useConfig)();
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var push = (0, _exchangeReactHooks.usePush)();
  var isDraft = (0, _exchangeReactHooks.useIsPortalDraft)();
  var isEdit = (0, _exchangeReactHooks.useIsPortalEdit)();
  var setDocumentMeta = (0, _exchangeReactHooks.useSetDocumentMeta)();
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var handleLoadMinorVersion = _react.default.useCallback( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref2) {
      var minorVersion, status, asset;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            minorVersion = _ref2.minorVersion, status = _ref2.status;
            _context2.next = 3;
            return dispatch((0, _actions.getAsset)({
              groupId: portalAsset.groupId,
              assetId: portalAsset.assetId,
              minorVersion: minorVersion,
              status: status,
              showLoading: false
            }));
          case 3:
            asset = _context2.sent;
            if (onLoad) {
              dispatch(onLoad({
                asset: asset,
                isDraft: isDraft,
                isEdit: isEdit,
                config: config,
                helpers: {
                  getPath: getPath,
                  push: push,
                  setDocumentMeta: setDocumentMeta,
                  trackEvent: trackEvent
                }
              }));
            }
            return _context2.abrupt("return", asset);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [dispatch, onLoad, portalAsset, config, getPath, push, isDraft, isEdit, setDocumentMeta, trackEvent]);
  return handleLoadMinorVersion;
};
//# sourceMappingURL=assets.js.map